import React from 'react';

import { IterableForm } from '../iterableForm';
import * as styles from './iterable-embed.module.css';

export const IterableEmbed = ({ iterableForm }) => {
	if (!iterableForm) {
		return null;
	}

	return (
		<div className={styles.moduleContainer}>
			<IterableForm iterableForm={iterableForm} />
		</div>
	);
};
